import { defaultAxios } from '@/services/index';

const gorgiasService = {
  async createGorgiasInfo(
    code: string,
    workspaceAlias: string,
    redirect_uri: string,
    subdomain: string,
  ) {
    try {
      const res = await defaultAxios.post(
        `/workspaces/${workspaceAlias}/gorgias/authenticated`,
        { code, redirect_uri, subdomain },
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },

  async getGorgiasInfo(alias: string) {
    try {
      const res = await defaultAxios.get(`/workspaces/${alias}/gorgias/`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async deleteGorgiasInfo(alias: string) {
    try {
      const res = await defaultAxios.delete(`/gorgias/${alias}`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async importWorkspaceFeedback(
    alias: string,
    startDate: string,
    endDate: string,
  ) {
    try {
      const res = await defaultAxios.post(`/gorgias/${alias}/import`, {
        start_date: startDate,
        end_date: endDate,
      });
      return res.data;
    } catch (e) {
      return false;
    }
  },
};

export default gorgiasService;
